import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Checkbox, FormControlLabel, Snackbar, Alert } from '@mui/material';
import { ModalsProps } from '../types/props.types';

const Modals: React.FC<ModalsProps> = ({
  openModal,
  setOpenModal,
  newLocationName,
  setNewLocationName,
  handleAddLocation,
  openAddFlowStateModal,
  setOpenAddFlowStateModal,
  newFlowStateData,
  setNewFlowStateData,
  handleAddFlowState,
  openCreateFlowModal,
  setOpenCreateFlowModal,
  newFlowData,
  setNewFlowData,
  handleCreateFlow,
  snackbar,
  handleSnackbarClose,
}) => {
  return (
    <>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Add New Location</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Location Name"
            type="text"
            fullWidth
            value={newLocationName}
            onChange={(e) => setNewLocationName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleAddLocation} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAddFlowStateModal} onClose={() => setOpenAddFlowStateModal(false)}>
        <DialogTitle>Add New Flow State</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Status"
            type="text"
            fullWidth
            value={newFlowStateData.status}
            onChange={(e) => setNewFlowStateData({ ...newFlowStateData, status: e.target.value })}
          />
          <TextField
            margin="dense"
            label="State"
            type="number"
            fullWidth
            value={newFlowStateData.state}
            onChange={(e) => setNewFlowStateData({ ...newFlowStateData, state: parseInt(e.target.value) || 0 })}
          />
          <TextField
            margin="dense"
            label="Next State"
            type="number"
            fullWidth
            value={newFlowStateData.nextState}
            onChange={(e) => setNewFlowStateData({ ...newFlowStateData, nextState: parseInt(e.target.value) || -1 })}
            helperText="Use -1 for completed state"
          />
          <TextField
            margin="dense"
            label="Location Index"
            type="number"
            fullWidth
            value={newFlowStateData.locationIndex}
            onChange={(e) => setNewFlowStateData({ ...newFlowStateData, locationIndex: parseInt(e.target.value) || -1 })}
            helperText="Use -1 for not used"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newFlowStateData.canClientAdvance}
                onChange={(e) => setNewFlowStateData({ ...newFlowStateData, canClientAdvance: e.target.checked })}
              />
            }
            label="Can Client Advance?"
            sx={{ mt: 1 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newFlowStateData.canContractorAdvance}
                onChange={(e) => setNewFlowStateData({ ...newFlowStateData, canContractorAdvance: e.target.checked })}
              />
            }
            label="Can Contractor Advance?"
            sx={{ mt: 1 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newFlowStateData.canClientCancel}
                onChange={(e) => setNewFlowStateData({ ...newFlowStateData, canClientCancel: e.target.checked })}
              />
            }
            label="Can Client Cancel?"
            sx={{ mt: 1 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newFlowStateData.canContractorCancel}
                onChange={(e) => setNewFlowStateData({ ...newFlowStateData, canContractorCancel: e.target.checked })}
              />
            }
            label="Can Contractor Cancel?"
            sx={{ mt: 1 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newFlowStateData.showTracker}
                onChange={(e) => setNewFlowStateData({ ...newFlowStateData, showTracker: e.target.checked })}
              />
            }
            label="Show Tracker?"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddFlowStateModal(false)}>Cancel</Button>
          <Button onClick={handleAddFlowState} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCreateFlowModal} onClose={() => setOpenCreateFlowModal(false)}>
        <DialogTitle>Create New Flow</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            value={newFlowData.name}
            onChange={(e) => setNewFlowData({ ...newFlowData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            value={newFlowData.description}
            onChange={(e) => setNewFlowData({ ...newFlowData, description: e.target.value })}
            multiline
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCreateFlowModal(false)}>Cancel</Button>
          <Button onClick={handleCreateFlow} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Modals;